module.exports = __webpack_public_path__ + "static/img/douying.8155775d.png";